/**
 * Help Menu
 * Handles dropdown toggle and chat widget integration
 */

class HelpMenu {
  constructor() {
    this.toggle = document.querySelector('[data-help-toggle]');
    this.dropdown = document.querySelector('[data-help-dropdown]');
    this.chatButton = document.querySelector('[data-help-chat]');

    if (!this.toggle || !this.dropdown) return;

    this.isOpen = false;
    this.init();
  }

  init() {
    // Toggle dropdown
    this.toggle.addEventListener('click', (e) => {
      e.stopPropagation();
      this.toggleDropdown();
    });

    // Chat button
    if (this.chatButton) {
      this.chatButton.addEventListener('click', () => {
        this.openChat();
        this.closeDropdown();
      });
    }

    // Close on outside click
    document.addEventListener('click', (e) => {
      if (this.isOpen && !this.toggle.contains(e.target) && !this.dropdown.contains(e.target)) {
        this.closeDropdown();
      }
    });

    // Close on ESC
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen) {
        this.closeDropdown();
      }
    });

    // Watch for Shopify Inbox to load dynamically
    this.watchForInbox();
  }

  toggleDropdown() {
    this.isOpen ? this.closeDropdown() : this.openDropdown();
  }

  openDropdown() {
    this.dropdown.classList.add('is-active');
    this.toggle.setAttribute('aria-expanded', 'true');
    this.isOpen = true;
  }

  closeDropdown() {
    this.dropdown.classList.remove('is-active');
    this.toggle.setAttribute('aria-expanded', 'false');
    this.isOpen = false;
  }

  openChat() {
    console.log('Help Menu: Attempting to open chat...');

    // Method 1: Try Shopify Inbox API
    if (window.ShopifyInbox && typeof window.ShopifyInbox.open === 'function') {
      console.log('Help Menu: Opening via ShopifyInbox.open()');
      window.ShopifyInbox.open();
      return;
    }

    // Method 2: Dispatch inbox:open event
    console.log('Help Menu: Trying inbox:open event');
    window.dispatchEvent(new CustomEvent('inbox:open'));

    // Method 3: Try to find inbox chat element (including shadow DOM)
    const inboxChat = document.querySelector('inbox-online-store-chat');
    if (inboxChat) {
      console.log('Help Menu: Found inbox-online-store-chat element');

      // Try clicking the element
      inboxChat.click();

      // Try clicking button inside shadow DOM
      if (inboxChat.shadowRoot) {
        const shadowButton = inboxChat.shadowRoot.querySelector('button');
        if (shadowButton) {
          console.log('Help Menu: Clicking shadow DOM button');
          shadowButton.click();
          return;
        }
      }
      return;
    }

    // Method 4: Try ShopifyChat element
    const chatWidget = document.getElementById('ShopifyChat');
    if (chatWidget) {
      console.log('Help Menu: Found ShopifyChat element');
      chatWidget.click();
      return;
    }

    // Method 5: Try generic chat button selectors
    const chatSelectors = [
      '.shopify-chat-button',
      '[aria-label*="chat" i]',
      '[data-shopify-chat]',
      'button[class*="chat" i]'
    ];

    for (const selector of chatSelectors) {
      const button = document.querySelector(selector);
      if (button) {
        console.log(`Help Menu: Found chat via selector: ${selector}`);
        button.click();
        return;
      }
    }

    // Method 6: Try iframe messaging for Shopify Inbox
    const inboxIframes = document.querySelectorAll('iframe[src*="shopify"]');
    if (inboxIframes.length > 0) {
      console.log('Help Menu: Trying iframe postMessage');
      inboxIframes.forEach(iframe => {
        try {
          iframe.contentWindow.postMessage({ type: 'OPEN_CHAT' }, '*');
        } catch (e) {
          console.warn('Help Menu: iframe postMessage failed', e);
        }
      });

      // Give iframe message time to work
      setTimeout(() => {
        if (!this.chatOpened) {
          console.warn('Help Menu: No chat method succeeded, showing fallback');
          this.showChatFallback();
        }
      }, 500);
      return;
    }

    // No chat found - show fallback
    console.warn('Help Menu: No chat widget detected');
    this.showChatFallback();
  }

  showChatFallback() {
    alert('Chat is currently unavailable. Please email us at support@libertyandvictory.com');
  }

  // Watch for Shopify Inbox to load dynamically
  watchForInbox() {
    const observer = new MutationObserver((mutations) => {
      const inboxElement = document.querySelector('inbox-online-store-chat');
      if (inboxElement) {
        console.log('Help Menu: Shopify Inbox detected dynamically');
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Stop watching after 30 seconds
    setTimeout(() => observer.disconnect(), 30000);
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new HelpMenu());
} else {
  new HelpMenu();
}
